"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccountSettings", {
  enumerable: true,
  get: function get() {
    return _account_settings.default;
  }
});
Object.defineProperty(exports, "Accounts", {
  enumerable: true,
  get: function get() {
    return _accounts.default;
  }
});
Object.defineProperty(exports, "AgentsApi", {
  enumerable: true,
  get: function get() {
    return _agents_api.default;
  }
});
Object.defineProperty(exports, "Assets", {
  enumerable: true,
  get: function get() {
    return _assets.default;
  }
});
Object.defineProperty(exports, "Auth", {
  enumerable: true,
  get: function get() {
    return _auth.default;
  }
});
Object.defineProperty(exports, "Basic", {
  enumerable: true,
  get: function get() {
    return _basic.default;
  }
});
Object.defineProperty(exports, "BasicDataHubApi", {
  enumerable: true,
  get: function get() {
    return _basic_data_hub_api.default;
  }
});
Object.defineProperty(exports, "BotTemplates", {
  enumerable: true,
  get: function get() {
    return _bot_templates.default;
  }
});
Object.defineProperty(exports, "Bots", {
  enumerable: true,
  get: function get() {
    return _bots.default;
  }
});
Object.defineProperty(exports, "CardTemplates", {
  enumerable: true,
  get: function get() {
    return _card_templates.default;
  }
});
Object.defineProperty(exports, "Cards", {
  enumerable: true,
  get: function get() {
    return _cards.default;
  }
});
Object.defineProperty(exports, "Clone", {
  enumerable: true,
  get: function get() {
    return _clone.default;
  }
});
Object.defineProperty(exports, "ContactsApi", {
  enumerable: true,
  get: function get() {
    return _contacts_api.default;
  }
});
Object.defineProperty(exports, "ContactsSettingsApi", {
  enumerable: true,
  get: function get() {
    return _contacts_settings_api.default;
  }
});
Object.defineProperty(exports, "ContentRequest", {
  enumerable: true,
  get: function get() {
    return _content_request.default;
  }
});
Object.defineProperty(exports, "Dashboard", {
  enumerable: true,
  get: function get() {
    return _dashboard.default;
  }
});
Object.defineProperty(exports, "Deployments", {
  enumerable: true,
  get: function get() {
    return _deployments.default;
  }
});
Object.defineProperty(exports, "DownloadCount", {
  enumerable: true,
  get: function get() {
    return _download_count.default;
  }
});
Object.defineProperty(exports, "Files", {
  enumerable: true,
  get: function get() {
    return _files.default;
  }
});
Object.defineProperty(exports, "FlowTemplates", {
  enumerable: true,
  get: function get() {
    return _flow_templates.default;
  }
});
Object.defineProperty(exports, "Flows", {
  enumerable: true,
  get: function get() {
    return _flows.default;
  }
});
Object.defineProperty(exports, "GraphApi", {
  enumerable: true,
  get: function get() {
    return _graph_api.default;
  }
});
Object.defineProperty(exports, "Helpers", {
  enumerable: true,
  get: function get() {
    return _helpers.default;
  }
});
Object.defineProperty(exports, "HitlApi", {
  enumerable: true,
  get: function get() {
    return _hitl_api.default;
  }
});
Object.defineProperty(exports, "HitlSettingsApi", {
  enumerable: true,
  get: function get() {
    return _hitl_settings_api.default;
  }
});
Object.defineProperty(exports, "IdentifiersApi", {
  enumerable: true,
  get: function get() {
    return _identifiers_api.default;
  }
});
Object.defineProperty(exports, "KeyValue", {
  enumerable: true,
  get: function get() {
    return _key_value.default;
  }
});
Object.defineProperty(exports, "LibraryCategories", {
  enumerable: true,
  get: function get() {
    return _library_categories.default;
  }
});
Object.defineProperty(exports, "Nlu", {
  enumerable: true,
  get: function get() {
    return _nlu.default;
  }
});
Object.defineProperty(exports, "Password", {
  enumerable: true,
  get: function get() {
    return _password.default;
  }
});
Object.defineProperty(exports, "PGSqlApi", {
  enumerable: true,
  get: function get() {
    return _pgsql_qpi.default;
  }
});
Object.defineProperty(exports, "ReportProblem", {
  enumerable: true,
  get: function get() {
    return _report_problem.default;
  }
});
Object.defineProperty(exports, "ReportingTags", {
  enumerable: true,
  get: function get() {
    return _reporting_tags.default;
  }
});
Object.defineProperty(exports, "Settings", {
  enumerable: true,
  get: function get() {
    return _settings.default;
  }
});
Object.defineProperty(exports, "Shared", {
  enumerable: true,
  get: function get() {
    return _shared.default;
  }
});
Object.defineProperty(exports, "StepTemplates", {
  enumerable: true,
  get: function get() {
    return _step_templates.default;
  }
});
Object.defineProperty(exports, "StoreApi", {
  enumerable: true,
  get: function get() {
    return _store_api.default;
  }
});
Object.defineProperty(exports, "SuggestItem", {
  enumerable: true,
  get: function get() {
    return _suggest_item.default;
  }
});
Object.defineProperty(exports, "TablesApi", {
  enumerable: true,
  get: function get() {
    return _tables_api.default;
  }
});
Object.defineProperty(exports, "Tags", {
  enumerable: true,
  get: function get() {
    return _tags.default;
  }
});
Object.defineProperty(exports, "Tickets", {
  enumerable: true,
  get: function get() {
    return _tickets.default;
  }
});
Object.defineProperty(exports, "Toolbox", {
  enumerable: true,
  get: function get() {
    return _toolbox.default;
  }
});
Object.defineProperty(exports, "UrlShortener", {
  enumerable: true,
  get: function get() {
    return _url_shortener.default;
  }
});
Object.defineProperty(exports, "UserProfile", {
  enumerable: true,
  get: function get() {
    return _user_profile.default;
  }
});
Object.defineProperty(exports, "Users", {
  enumerable: true,
  get: function get() {
    return _users.default;
  }
});
Object.defineProperty(exports, "Utils", {
  enumerable: true,
  get: function get() {
    return _utils.default;
  }
});
Object.defineProperty(exports, "ViewTemplates", {
  enumerable: true,
  get: function get() {
    return _view_templates.default;
  }
});
Object.defineProperty(exports, "Views", {
  enumerable: true,
  get: function get() {
    return _views.default;
  }
});
exports.default = exports.BasicDataHunApi = void 0;

var _account_settings = _interopRequireDefault(require("./account_settings"));

var _accounts = _interopRequireDefault(require("./accounts"));

var _agents_api = _interopRequireDefault(require("./agents_api"));

var _assets = _interopRequireDefault(require("./assets"));

var _auth = _interopRequireDefault(require("./auth"));

var _basic = _interopRequireDefault(require("./_basic"));

var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));

var _bot_templates = _interopRequireDefault(require("./bot_templates"));

var _bots = _interopRequireDefault(require("./bots"));

var _card_templates = _interopRequireDefault(require("./card_templates"));

var _cards = _interopRequireDefault(require("./cards"));

var _clone = _interopRequireDefault(require("./clone"));

var _contacts_api = _interopRequireDefault(require("./contacts_api"));

var _contacts_settings_api = _interopRequireDefault(require("./contacts_settings_api"));

var _content_request = _interopRequireDefault(require("./content_request"));

var _dashboard = _interopRequireDefault(require("./dashboard"));

var _deployments = _interopRequireDefault(require("./deployments"));

var _download_count = _interopRequireDefault(require("./download_count"));

var _files = _interopRequireDefault(require("./files"));

var _flow_templates = _interopRequireDefault(require("./flow_templates"));

var _flows = _interopRequireDefault(require("./flows"));

var _graph_api = _interopRequireDefault(require("./graph_api"));

var _helpers = _interopRequireDefault(require("./lib/helpers"));

var _hitl_api = _interopRequireDefault(require("./hitl_api"));

var _hitl_settings_api = _interopRequireDefault(require("./hitl_settings_api"));

var _identifiers_api = _interopRequireDefault(require("./identifiers_api"));

var _key_value = _interopRequireDefault(require("./key_value"));

var _library_categories = _interopRequireDefault(require("./library_categories"));

var _nlu = _interopRequireDefault(require("./nlu"));

var _password = _interopRequireDefault(require("./password"));

var _pgsql_qpi = _interopRequireDefault(require("./pgsql_qpi"));

var _report_problem = _interopRequireDefault(require("./report_problem"));

var _reporting_tags = _interopRequireDefault(require("./reporting_tags"));

var _settings = _interopRequireDefault(require("./settings"));

var _shared = _interopRequireDefault(require("./shared"));

var _step_templates = _interopRequireDefault(require("./step_templates"));

var _store_api = _interopRequireDefault(require("./store_api"));

var _suggest_item = _interopRequireDefault(require("./suggest_item"));

var _tables_api = _interopRequireDefault(require("./tables_api"));

var _tags = _interopRequireDefault(require("./tags"));

var _tickets = _interopRequireDefault(require("./tickets"));

var _toolbox = _interopRequireDefault(require("./toolbox"));

var _url_shortener = _interopRequireDefault(require("./url_shortener"));

var _user_profile = _interopRequireDefault(require("./user_profile"));

var _users = _interopRequireDefault(require("./users"));

var _utils = _interopRequireDefault(require("./lib/utils"));

var _view_templates = _interopRequireDefault(require("./view_templates"));

var _views = _interopRequireDefault(require("./views"));

var BasicDataHunApi = _basic_data_hub_api.default; // fixed typo but left datahun for compatibility

exports.BasicDataHunApi = BasicDataHunApi;
var _default = {
  AccountSettings: _account_settings.default,
  Accounts: _accounts.default,
  AgentsApi: _agents_api.default,
  Assets: _assets.default,
  Auth: _auth.default,
  Basic: _basic.default,
  BasicDataHunApi: BasicDataHunApi,
  BasicDataHubApi: _basic_data_hub_api.default,
  BotTemplates: _bot_templates.default,
  Bots: _bots.default,
  CardTemplates: _card_templates.default,
  Cards: _cards.default,
  Clone: _clone.default,
  ContactsApi: _contacts_api.default,
  ContactsSettingsApi: _contacts_settings_api.default,
  ContentRequest: _content_request.default,
  Dashboard: _dashboard.default,
  Deployments: _deployments.default,
  DownloadCount: _download_count.default,
  Files: _files.default,
  FlowTemplates: _flow_templates.default,
  Flows: _flows.default,
  GraphApi: _graph_api.default,
  Helpers: _helpers.default,
  HitlApi: _hitl_api.default,
  HitlSettingsApi: _hitl_settings_api.default,
  IdentifiersApi: _identifiers_api.default,
  KeyValue: _key_value.default,
  LibraryCategories: _library_categories.default,
  Nlu: _nlu.default,
  Password: _password.default,
  PGSqlApi: _pgsql_qpi.default,
  ReportProblem: _report_problem.default,
  ReportingTags: _reporting_tags.default,
  Settings: _settings.default,
  Shared: _shared.default,
  StepTemplates: _step_templates.default,
  SuggestItem: _suggest_item.default,
  StoreApi: _store_api.default,
  TablesApi: _tables_api.default,
  Tags: _tags.default,
  Tickets: _tickets.default,
  Toolbox: _toolbox.default,
  UrlShortener: _url_shortener.default,
  UserProfile: _user_profile.default,
  Users: _users.default,
  Utils: _utils.default,
  ViewTemplates: _view_templates.default,
  Views: _views.default
};
exports.default = _default;